import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CarouselStyles } from "styles/style";
import { utils } from "supabase/content/utils.ts";
import { api } from "supabase/database/api.ts";

const STORAGE_BASE = "https://zegleedmcpswaxynxnta.supabase.co/storage/v1/object/public/assets";
const EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp"];

const getDefaultThumbnail = async () => {
  const data = await api.defaultThumbnailsQueries.getDefaultThumbnails();
  return data.default;
}

// Thumbnail component that tries multiple extensions
const Thumbnail = ({ uuid, alt, ...props }) => {
  const [extIndex, setExtIndex] = useState(0);

  if (!uuid) uuid = getDefaultThumbnail();

  // If uuid already has extension, use it directly
  const hasExtension = /\.[a-zA-Z0-9]+$/.test(uuid);
  const src = hasExtension
    ? `${STORAGE_BASE}/${uuid}`
    : `${STORAGE_BASE}/${uuid}${EXTENSIONS[extIndex]}`;

  const handleError = () => {
    // Try next extension
    if (!hasExtension && extIndex < EXTENSIONS.length - 1) {
      setExtIndex(extIndex + 1);
    }
  };

  return <CarouselStyles.MobileThumb src={src} alt={alt} onError={handleError} {...props} />;
};

export const VideoCard = ({ video, idx, table = "service" }) => {
  return (
    <CarouselStyles.VideoCardContainer>
      <CarouselStyles.MobileCard
        as={Link}
        to={`./${video.id ?? utils.formattedDate(video.date)}`}
      >
        <CarouselStyles.MobileThumbWrapper>
          <Thumbnail uuid={video.thumbnail} alt={video.date} />
        </CarouselStyles.MobileThumbWrapper>
        <div tw="flex flex-col justify-between">
          <CarouselStyles.VideoCardTitle>{video.title}</CarouselStyles.VideoCardTitle>
        </div>
      </CarouselStyles.MobileCard>

      {/* Desktop Layout */}
      <CarouselStyles.DesktopCard
        as={Link}
        to={`./${video.id ?? utils.formattedDate(video.date)}`}
      >
        <CarouselStyles.VideoPlayer>
          <Thumbnail uuid={video.thumbnail} alt={video.date} />
        </CarouselStyles.VideoPlayer>

        <CarouselStyles.CardContentContainer>
          <CarouselStyles.VideoCardTitle>{video.title}</CarouselStyles.VideoCardTitle>
        </CarouselStyles.CardContentContainer>
      </CarouselStyles.DesktopCard>
    </CarouselStyles.VideoCardContainer>
  );
}
